type EntityItem = {
  post: any;
  parentComment?: null | NonNullable<unknown>;
  international: any;
  id: string;
  entity: string;
  subCategory?: { header?: string | null; id?: string | null; categoryId?: string | null };
  category?: { name?: string | null; id?: string | null };
  article?: { name?: string | null; id?: string | null };
  business?: { name?: string | null };
  international_community?: { name?: string | null; id?: string | null };
  text?: string | null;
};

type EntityMeta = {
  title: string;
  link: string;
  kind: 'subcategory' | 'category' | 'article' | 'post' | 'international_community' | 'unknown' | 'reply';
  kindLabel: string;
};

const KIND_LABEL: Record<EntityMeta['kind'], string> = {
  subcategory: 'Subcategory',
  category: 'Category',
  article: 'Article',
  post: 'Post',
  international_community: 'International',
  unknown: 'Unknown',
  reply: 'Reply',
};

export function getPublicDomain(): string {
  const apiUrl = process.env.REACT_APP_API || '';

  try {
    const url = new URL(apiUrl);

    const host = url.hostname.replace(/^api\./, '');

    return `${url.protocol}//${host}/`;
  } catch {
    console.error('Invalid REACT_APP_API value:', apiUrl);

    return '';
  }
}

export function getEntityMeta(item: EntityItem): EntityMeta {
  const domain = getPublicDomain();
  let title = 'Untitled';
  let kind: EntityMeta['kind'] = 'unknown';
  let link = '';

  if (item.parentComment) {
    return { title: '', kind: 'reply', kindLabel: KIND_LABEL.reply, link: '' };
  }

  switch (item.entity) {
    case 'subcategory':
      title = item.subCategory?.header || 'Unknown subcategory';
      kind = 'subcategory';
      link = `${domain}categories/${item.subCategory?.categoryId}/${item.subCategory?.id}`;
      break;
    case 'category':
      title = item.category?.name || 'Unknown category';
      kind = 'category';
      link = `${domain}categories/${item.category?.id}`;
      break;
    case 'article':
      title = item.article?.name || 'Untitled article';
      kind = 'article';
      link = `${domain}tipping-articles/${item.article?.id}`;
      break;
    case 'international_community':
      title = item.international?.country?.name || 'International Community';
      kind = 'international_community';
      link = `${domain}international/${item.international?.id || ''}`;
      break;
    case 'post':
      // eslint-disable-next-line no-nested-ternary
      title = item.post?.text
        ? (item.post.text.length > 20
          ? `${item.post.text.slice(0, 20)}...`
          : item.post.text)
        : 'Unnamed post';
      kind = 'post';
      link = `${domain}share-your-two-cents/${item?.post?.id || ''}`;
      break;
    default:
      title = item.text || 'Untitled';
      kind = 'unknown';
      break;
  }

  return {
    title,
    kind,
    kindLabel: KIND_LABEL[kind],
    link,
  };
}
